export default "__VITE_ASSET__DEGcswhJ__"